/** Scroll progress windows shared by OrbBeat and the glass marble. */
export const GLASS_TIMING = {
  condense: [0.44, 0.64],
  morph: [0.64, 0.76],
  handoff: 0.76,
} as const;

export type GlassLook = 'original' | 'middle' | 'emerald';
